import React from 'react';
import WaterDecadeRouter from './WaterDecadeRouter';

export default function WaterDecadePage() {
  return <WaterDecadeRouter />;
}
